// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l8-1";
export var rowFirst = "_l8-3";
export var rowLast = "_l8-5";
export var rowMiddle = "_l8-4";
export var ticketListScroll = "_l8-2";
export var ticketStack = "_l8-0";